module.exports = __webpack_public_path__ + "img/trash2.46cfeea2.svg";